import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import thunkMiddleware from "redux-thunk";
import BusinessGroupReducer from "./reducers/busigroup.reducers";
import BgBubbleChart from "./components/heatmap/bgchart.component";
import ErrorBoundary from "./components/common/errorboundary";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

const initbussGroupComp = function(data) {
  const busiGroupStore = createStore(
    BusinessGroupReducer,
    data,
    applyMiddleware(thunkMiddleware)
  );

  ReactDOM.render(
    <Provider store={busiGroupStore}>
      <ErrorBoundary>
        <Suspense fallback="loading...">
          <I18nextProvider i18n={i18n}>
            <BgBubbleChart />
          </I18nextProvider>
        </Suspense>,
      </ErrorBoundary>
    </Provider>,
    document.getElementById("bgroup-comp")
  );
};

window.initbussGroupComp = initbussGroupComp;
